var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 119,
    viewBox: "0 0 96 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notes-rafiki"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Board--inject-88"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.788086,
    y: 13.8918,
    width: 73.5505,
    height: 53.2447,
    rx: 4.03576,
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 36.4941,
    y: 11.4803,
    width: 2.13982,
    height: 105.123,
    rx: 0.965612,
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M35.27 114.475H39.8498C40.8403 114.475 41.6433 115.274 41.6433 116.259V116.477C41.6433 116.51 41.6299 116.543 41.6061 116.566C41.5823 116.59 41.55 116.603 41.5163 116.603H33.6036C33.5334 116.603 33.4766 116.547 33.4766 116.477V116.259C33.4766 115.274 34.2795 114.475 35.27 114.475V114.475Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    x: 57.959,
    y: 12.5521,
    width: 6.15775,
    height: 0.382752,
    fill: "#FF7171"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    x: 52.4023,
    y: 12.5521,
    width: 1.88196,
    height: 0.382752,
    fill: "#FF7171"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    x: 1.06152,
    y: 13.8916,
    width: 73.5505,
    height: 53.2447,
    rx: 4.03576,
    fill: "#FF7171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6",
    opacity: 0.7,
    d: "M69.2027 15.8049C71.1262 15.8049 72.6855 17.3642 72.6855 19.2877V61.7393C72.6855 63.6628 71.1262 65.2221 69.2027 65.2221H6.46648C4.54297 65.2221 2.98367 63.6628 2.98367 61.7393V19.2877C2.98367 17.3642 4.54298 15.8049 6.46648 15.8049L69.2027 15.8049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    opacity: 0.2,
    d: "M23.2636 39.8767C18.7759 39.4589 14.2698 39.2698 9.7627 39.3102C9.80503 33.2245 10.3515 26.6449 10.8326 20.1726L24.0641 21.0185C23.5522 28.5702 23.0442 36.1449 23.2636 39.8767Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M23.5175 39.6049C19.03 39.1852 14.5237 38.9962 10.0166 39.0385C10.0589 32.9489 10.3399 26.6488 10.821 20.1726L24.3218 20.7391C23.8177 28.2908 23.3096 35.8693 23.5175 39.6049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    opacity: 0.2,
    d: "M41.2366 52.8405L27.7396 53.4261L27.1777 34.2846L40.413 33.9746L41.2366 52.8405Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7",
    d: "M27.1748 34.2904L40.6745 33.7066L41.4993 52.5699L27.9996 53.1537L27.1748 34.2904Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    opacity: 0.2,
    d: "M71.3266 52.3852L57.9297 50.6284L60.7238 31.6821L73.809 33.6648L71.3266 52.3852Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8",
    d: "M60.7191 31.6868L74.1153 33.4455L71.6307 52.1643L58.2345 50.4056L60.7191 31.6868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    opacity: 0.2,
    d: "M25.2733 66.2246C22.8256 66.9901 16.5216 67.1088 11.8032 66.8753C11.1297 60.9809 11.199 54.3823 11.3683 47.7377L24.6037 47.5195C24.3112 52.0819 24.5382 60.2001 25.2733 66.2246Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M25.5435 65.9503C23.092 66.7158 16.788 66.8306 12.0734 66.5971C11.4049 60.3307 11.1709 54.0259 11.373 47.7274L24.8739 47.2299C24.5775 51.8076 24.8046 59.9257 25.5435 65.9503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    opacity: 0.2,
    d: "M58.4673 37.9631L44.9588 38.2579C44.5047 31.9731 44.6355 25.4012 44.8087 19.1202H58.0517C57.9016 25.7993 58.0017 32.1721 58.4673 37.9631Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M58.7334 37.6803L45.2248 37.975C44.7733 31.6902 44.6373 25.3978 44.8169 19.0977L58.3255 18.803C58.1792 25.5241 58.287 31.8931 58.7334 37.6803Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Character--inject-88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    d: "M63.3831 112.333L60.3867 111.536L61.4538 104.447L64.4502 105.244L63.3831 112.333Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    d: "M91.0992 115.027H87.9946L85.5781 107.903H88.6828L91.0992 115.027Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    d: "M87.5835 114.67H91.3686C91.4952 114.671 91.6044 114.758 91.6315 114.881L92.2463 117.617C92.2746 117.752 92.2393 117.892 92.1505 117.998C92.0617 118.104 91.929 118.164 91.79 118.161C90.5721 118.142 89.6868 118.069 88.1518 118.069C87.2085 118.069 84.3628 118.169 83.0638 118.169C81.7647 118.169 81.5907 116.893 82.1242 116.774C84.5136 116.257 86.3153 115.544 87.0809 114.858C87.2204 114.738 87.3987 114.671 87.5835 114.67V114.67Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    d: "M60.5013 111.198L63.7722 112.068C63.8947 112.102 63.9779 112.214 63.9733 112.34L63.8496 115.138C63.8454 115.275 63.7775 115.402 63.6656 115.483C63.5538 115.564 63.4104 115.589 63.2773 115.551C62.1174 115.218 60.4124 114.693 58.9277 114.298C57.1918 113.839 55.6684 113.532 53.6348 112.992C52.4053 112.666 52.3975 111.34 52.9427 111.367C55.4249 111.482 57.3541 111.938 59.7165 111.237C59.9693 111.151 60.2412 111.138 60.5013 111.198Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    d: "M76.5461 23.3124C75.5215 24.5884 74.4583 25.9602 73.453 27.3051C72.4478 28.6501 71.4812 30.041 70.592 31.4358C70.1473 32.1294 69.7414 32.8344 69.3509 33.5356L68.2838 35.6163L68.1949 35.8041C68.1949 35.8232 68.1717 35.8385 68.1678 35.8347C68.1626 35.7889 68.1626 35.7426 68.1678 35.6968C68.1674 35.5782 68.1544 35.4601 68.1291 35.3442C68.1155 35.2805 68.0975 35.2177 68.075 35.1565C68.075 35.1182 68.0479 35.0798 68.0325 35.0415C68.0133 34.9875 67.99 34.935 67.9629 34.8844C67.8938 34.7558 67.8109 34.635 67.7154 34.5242C67.5808 34.3729 67.4229 34.2436 67.2476 34.1411C67.0699 34.0392 66.8766 33.9667 66.6754 33.9265C66.525 33.8989 66.3719 33.8886 66.2192 33.8958C66.0456 33.9039 65.8745 33.9401 65.7127 34.0031C65.5992 34.0419 65.4923 34.0974 65.3956 34.1679C65.299 34.2407 65.3029 34.2522 65.299 34.2598C65.2951 34.2675 65.3222 34.2598 65.3454 34.2598C65.4827 34.1672 65.612 34.0633 65.732 33.9495C65.8789 33.823 66.0259 33.6851 66.1728 33.5395C66.7721 32.9685 67.3907 32.3401 68.0363 31.7538L69.9888 33.0107C69.6757 33.8726 69.2984 34.7103 68.8599 35.5167C68.6211 35.9764 68.3389 36.4126 68.017 36.8195C67.9575 36.8929 67.8943 36.9632 67.8276 37.0302C67.7206 37.1412 67.6028 37.2414 67.4757 37.3291C67.3317 37.4282 67.1759 37.5093 67.0118 37.5705C66.8231 37.64 66.625 37.6813 66.4241 37.6931C66.2583 37.7009 66.0922 37.6893 65.9292 37.6586C65.7139 37.6169 65.5073 37.5392 65.3183 37.4287C65.1313 37.3205 64.9629 37.1834 64.8196 37.0226C64.7158 36.9048 64.625 36.7763 64.5489 36.6394C64.5219 36.5819 64.4909 36.5206 64.4677 36.4631L64.4175 36.329C64.3865 36.2294 64.3711 36.1681 64.3556 36.0991C64.3208 35.9302 64.3052 35.758 64.3092 35.5856C64.3115 35.4317 64.3244 35.2781 64.3479 35.1258C64.3479 35.0147 64.3788 34.9266 64.3943 34.8423C64.4291 34.6737 64.46 34.5357 64.4909 34.4016C64.6185 33.8767 64.7538 33.436 64.9085 32.9915C65.0631 32.547 65.2642 32.1025 65.4614 31.6772C65.848 30.8189 66.2733 29.9912 66.7218 29.1942C67.6118 27.612 68.5848 26.0772 69.637 24.5961C70.1551 23.8642 70.6886 23.14 71.2376 22.4311C71.7867 21.7222 72.3434 21.0363 72.9582 20.3236L76.5461 23.3124Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    d: "M78.2322 21.0559C78.8972 23.9182 72.5525 31.2484 72.5525 31.2484L66.8613 27.1178C68.1248 24.7429 69.6413 22.509 71.3849 20.4543C73.9908 17.5344 77.5014 17.91 78.2322 21.0559Z",
    fill: "#FF7171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    opacity: 0.2,
    d: "M78.2322 21.0559C78.8972 23.9182 72.5525 31.2484 72.5525 31.2484L66.8613 27.1178C68.1248 24.7429 69.6413 22.509 71.3849 20.4543C73.9908 17.5344 77.5014 17.91 78.2322 21.0559Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    opacity: 0.2,
    d: "M61.4503 104.447L60.8975 108.103L63.8977 108.9L64.4467 105.244L61.4503 104.447Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    opacity: 0.2,
    d: "M88.6828 107.907H85.5781L86.8269 111.578H89.9316L88.6828 107.907Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    d: "M92.1161 20.6267C88.0758 32.0914 88.0023 44.5064 87.55 46.9971C85.1374 46.6791 76.0516 45.4644 71.0988 44.8015C69.9853 27.1982 74.8646 18.4771 74.8646 18.4771C74.8646 18.4771 75.9394 18.3353 77.3932 18.274C77.8494 18.274 78.3404 18.2433 78.8508 18.2472C79.133 18.2472 79.4191 18.2472 79.7091 18.2663C82.0569 18.4501 84.3922 18.7674 86.7033 19.2166C87.1402 19.2971 87.5848 19.389 88.0139 19.4848C88.4431 19.5806 88.7872 19.6726 89.1738 19.7684C90.8325 20.186 92.1161 20.6267 92.1161 20.6267Z",
    fill: "#FF7171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    opacity: 0.2,
    d: "M92.1161 20.6267C88.0758 32.0914 88.0023 44.5064 87.55 46.9971C85.1374 46.6791 76.0516 45.4644 71.0988 44.8015C69.9853 27.1982 74.8646 18.4771 74.8646 18.4771C74.8646 18.4771 75.9394 18.3353 77.3932 18.274C77.8494 18.274 78.3404 18.2433 78.8508 18.2472C79.133 18.2472 79.4191 18.2472 79.7091 18.2663C82.0569 18.4501 84.3922 18.7674 86.7033 19.2166C87.1402 19.2971 87.5848 19.389 88.0139 19.4848C88.4431 19.5806 88.7872 19.6726 89.1738 19.7684C90.8325 20.186 92.1161 20.6267 92.1161 20.6267Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    opacity: 0.2,
    d: "M88.3344 25.9071C87.681 27.6352 88.1914 32.4212 88.9066 34.0535C89.1618 32.3445 89.475 30.5512 89.8694 28.712L88.3344 25.9071Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    d: "M68.0684 31.5322L70.5273 29.2332L72.128 32.8274C71.2186 33.7505 69.8106 33.983 68.6483 33.4021L68.0684 31.5322Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    d: "M72.3319 28.0369L73.5614 31.2173L72.127 32.8074L70.5264 29.2132L72.3319 28.0369Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    d: "M87.0703 11.3035C86.3241 13.4761 85.3305 17.5033 86.703 19.2008C85.315 20.243 83.5249 21.4194 80.8417 21.155C78.1585 20.8906 78.8737 19.1318 79.7089 18.2658C82.2993 18.0091 82.4849 16.1545 82.2838 14.3612L87.0703 11.3035Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    d: "M79.2333 17.6835C79.2333 17.0781 81.7464 16.5684 81.843 17.1432C81.9397 17.718 81.0698 17.9096 81.3443 18.6759C81.6188 19.4423 84.1512 19.5189 85.1642 18.4345C85.8369 17.7103 86.0496 16.9823 86.904 17.4612C87.7585 17.9402 88.7869 18.6108 88.2224 19.6645C87.658 20.7183 84.4721 23.2089 81.5724 22.569C78.6726 21.9291 77.8646 20.3849 78.4291 19.7143C78.9202 19.1464 79.2035 18.4309 79.2333 17.6835Z",
    fill: "#FF7171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    opacity: 0.2,
    d: "M85.1182 12.5526L82.2842 14.3612C82.3391 14.7778 82.3559 15.1985 82.3344 15.618C83.4869 15.5709 84.5391 14.9553 85.1375 13.978C85.4623 13.3611 85.354 12.6599 85.1182 12.5526Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    d: "M87.5387 7.47208C87.2642 10.5145 87.2564 12.3078 85.6597 13.829C83.2587 16.1281 79.5045 14.5954 78.8588 11.5529C78.2789 8.79788 78.8279 4.27253 81.8668 3.16131C83.228 2.6474 84.7607 2.8694 85.9166 3.74791C87.0725 4.62641 87.6864 6.03588 87.5387 7.47208Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    d: "M87.7743 5.03925C85.5163 4.87065 85.3269 8.75609 87.1943 10.4268C89.4522 9.54927 92.6072 5.38028 87.7743 5.03925Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    d: "M85.5386 5.64433C84.2163 3.57516 81.6722 6.85518 80.4157 4.59442C79.6618 3.23413 78.3743 4.70937 77.5894 3.8932C76.8046 3.07703 78.0186 0.885241 78.8382 0.689819C78.3781 1.18412 78.2892 2.95058 79.6695 2.07693C81.0498 1.20328 82.0395 0.298976 83.7291 1.76655C85.4187 3.23413 87.1856 0.283649 88.736 2.53291C90.0969 4.48713 87.1044 8.10434 85.5386 5.64433Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    d: "M88.0941 5.32267C87.7314 5.32134 87.3713 5.26314 87.027 5.15024C86.9512 5.12696 86.9088 5.04718 86.9323 4.97206C86.9557 4.89693 87.0362 4.8549 87.112 4.87818C88.1018 5.18855 89.0645 5.02379 89.5053 4.47201C89.8494 4.04285 89.8223 3.45275 89.4396 2.81284C89.399 2.74512 89.4215 2.65763 89.4898 2.61742C89.5582 2.57721 89.6464 2.59951 89.687 2.66723C90.1316 3.40294 90.1471 4.12715 89.7334 4.64827C89.3197 5.10953 88.7158 5.35795 88.0941 5.32267Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    d: "M88.8309 10.8708C88.3984 11.5073 87.7302 11.9493 86.9712 12.1008C85.962 12.2886 85.5445 11.3766 85.8963 10.4761C86.2134 9.66761 87.1219 8.59471 88.1001 8.80929C89.0783 9.02387 89.3528 10.0814 88.8309 10.8708Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    d: "M59.7939 107.011L64.8666 108.359C64.8666 108.359 69.6956 90.6336 71.2228 81.1537C71.6867 78.276 72.7229 74.291 73.9756 70.0415C75.553 64.677 77.4746 58.8987 79.0327 54.3733C80.6798 49.6066 81.9131 46.2384 81.9131 46.2384L71.0875 44.7938C71.0875 44.7938 62.8483 69.8269 61.9204 79.1688C60.9654 88.8901 59.7939 107.011 59.7939 107.011Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    opacity: 0.2,
    d: "M73.9763 70.049C75.5538 64.6845 77.4753 58.9061 79.0335 54.3808L78.0746 51.9016C75.1633 54.9057 73.7985 64.6806 73.9763 70.049Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    d: "M76.9329 45.5833C76.9329 45.5833 76.3994 71.9345 77.1262 80.9162C77.9266 90.7563 85.3654 110.866 85.3654 110.866H91.0488C91.0488 110.866 87.256 92.4729 86.0961 82.8934C84.7699 72.0111 87.5498 46.9895 87.5498 46.9895L76.9329 45.5833Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    d: "M84.6872 110.989H91.3798V109.008L83.8984 108.877L84.6872 110.989Z",
    fill: "#FF7171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    d: "M59.123 106.957L65.17 108.566L65.6958 106.631L59.3009 104.826L59.123 106.957Z",
    fill: "#FF7171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    d: "M82.8497 8.19644C82.8497 8.44168 82.7066 8.64093 82.5404 8.6371C82.3741 8.63327 82.2504 8.42635 82.2582 8.17728C82.2659 7.92822 82.4051 7.7328 82.5675 7.73663C82.7298 7.74046 82.8574 7.94738 82.8497 8.19644Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    d: "M80.0281 8.10488C80.0281 8.35394 79.8812 8.54936 79.7188 8.54553C79.5564 8.5417 79.4288 8.33478 79.4327 8.08955C79.4366 7.84431 79.5796 7.64123 79.742 7.64889C79.9044 7.65656 80.032 7.8673 80.0281 8.10488Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    d: "M80.9206 8.26465C80.6018 9.01413 80.1789 9.71575 79.6641 10.3491C80.0028 10.6059 80.4392 10.7 80.8549 10.6059L80.9206 8.26465Z",
    fill: "#FF5652"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    d: "M81.8903 11.3001C82.4549 11.2526 82.9743 10.9751 83.3247 10.5338C83.3512 10.5058 83.3512 10.4622 83.3247 10.4341C83.3084 10.4225 83.288 10.418 83.2683 10.4216C83.2486 10.4252 83.2313 10.4367 83.2203 10.4533C82.8147 10.9455 82.1937 11.2126 81.5539 11.1699C81.5337 11.1688 81.5141 11.176 81.4994 11.1898C81.4848 11.2035 81.4765 11.2227 81.4766 11.2427C81.4765 11.2814 81.5071 11.3134 81.5462 11.3155C81.6611 11.319 81.7761 11.3139 81.8903 11.3001Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    d: "M83.7523 7.31508C83.7776 7.31259 83.8016 7.30332 83.8219 7.28826C83.8537 7.26591 83.8752 7.23195 83.8818 7.19386C83.8883 7.15577 83.8793 7.11667 83.8567 7.08517C83.5905 6.69666 83.1512 6.45969 82.6775 6.4491C82.6385 6.45108 82.6019 6.46835 82.5758 6.49711C82.5497 6.52586 82.5362 6.56374 82.5383 6.60237C82.5393 6.64067 82.5559 6.67694 82.5843 6.70292C82.6127 6.72891 82.6505 6.7424 82.6891 6.74031C83.064 6.7527 83.4097 6.94399 83.617 7.25377C83.6481 7.29638 83.6995 7.31966 83.7523 7.31508Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    d: "M78.8453 7.11558C78.8936 7.11114 78.9361 7.0821 78.9574 7.03894C79.1201 6.70275 79.4372 6.46563 79.808 6.40286C79.8803 6.38616 79.9286 6.31871 79.9207 6.24562C79.9129 6.17253 79.8513 6.11671 79.7771 6.11548C79.3087 6.18748 78.9057 6.4824 78.6984 6.90483C78.6796 6.93871 78.6755 6.97873 78.6872 7.01563C78.6989 7.05253 78.7253 7.08309 78.7603 7.10025C78.7861 7.11472 78.816 7.12012 78.8453 7.11558Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.3672 115.136C87.1014 115.206 86.8292 115.245 86.5553 115.253C86.3431 115.268 86.1323 115.208 85.956 115.084C85.8461 114.983 85.7899 114.832 85.8052 114.68C85.8063 114.589 85.8553 114.505 85.9328 114.462C86.2634 114.286 87.2179 114.887 87.3784 114.988C87.3831 114.991 87.3871 114.993 87.3904 114.995C87.4135 115.013 87.4254 115.042 87.4213 115.072C87.4176 115.103 87.3962 115.128 87.3672 115.136ZM87.1357 115.031C87.1421 115.03 87.1484 115.029 87.1548 115.027V115.044C87.1485 115.039 87.1421 115.035 87.1357 115.031ZM86.0529 114.967C86.221 115.114 86.6155 115.136 87.1357 115.031C86.7316 114.773 86.1891 114.504 85.9988 114.6C85.968 114.619 85.9501 114.655 85.9524 114.692C85.9375 114.796 85.9756 114.9 86.0529 114.967Z",
    fill: "#FF7171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.3983 115.098C87.3844 115.102 87.3697 115.102 87.3558 115.098L87.321 115.102C87.0001 114.93 86.3815 114.255 86.4472 113.911C86.4694 113.801 86.5666 113.722 86.6792 113.723C86.7922 113.706 86.9068 113.74 86.9924 113.815C87.3519 114.106 87.4293 114.995 87.4293 115.033C87.4331 115.059 87.4209 115.085 87.3983 115.098ZM86.8975 113.925C86.8513 113.883 86.7904 113.86 86.7274 113.86H86.6965C86.5882 113.872 86.5882 113.918 86.5882 113.937C86.5496 114.121 86.9439 114.646 87.2648 114.887C87.2442 114.537 87.116 114.201 86.8975 113.925Z",
    fill: "#FF7171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1548 111.486C60.144 111.511 60.1204 111.528 60.093 111.532L60.0814 111.536C59.571 111.501 58.6818 111.398 58.4304 111.014C58.3547 110.901 58.3403 110.757 58.3918 110.631C58.416 110.554 58.4789 110.494 58.558 110.474C58.9756 110.371 60.0195 111.298 60.1355 111.405C60.1582 111.425 60.1659 111.457 60.1548 111.486ZM59.8743 111.378C59.4568 111.014 58.873 110.612 58.6255 110.612L58.5946 110.627C58.5631 110.635 58.5391 110.661 58.5327 110.692C58.4971 110.774 58.5059 110.868 58.5559 110.941C58.6951 111.152 59.1823 111.309 59.8743 111.378Z",
    fill: "#FF7171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1155 111.533H60.0962C60.0774 111.534 60.0585 111.53 60.0421 111.521C59.7134 111.26 59.1799 110.433 59.3268 110.111C59.3616 110.034 59.4428 109.954 59.6438 109.984C59.7914 110.007 59.9231 110.088 60.0073 110.211C60.2751 110.579 60.1862 111.283 60.1657 111.446C60.1634 111.464 60.1619 111.475 60.1619 111.479C60.1568 111.503 60.1393 111.524 60.1155 111.533ZM59.6208 110.114H59.5434C59.4886 110.118 59.4702 110.142 59.4641 110.151C59.4633 110.152 59.4627 110.152 59.4622 110.153C59.3733 110.352 59.7251 110.984 60.0345 111.302C60.0906 110.956 60.0394 110.6 59.8875 110.283C59.8269 110.192 59.7299 110.13 59.6208 110.114Z",
    fill: "#FF7171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    d: "M92.924 23.0018C93.3725 24.9982 93.7514 26.9831 94.0839 28.9909C94.4164 30.9988 94.7141 33.0105 94.9461 35.049L95.0273 35.8154L95.0737 36.2905C95.1091 36.6626 95.075 37.038 94.9732 37.3979C94.8354 37.8981 94.558 38.3497 94.1728 38.7007C93.8508 38.9874 93.4675 39.1983 93.0516 39.3176C92.5679 39.4527 92.0623 39.493 91.5631 39.4364C90.9145 39.3657 90.2763 39.2217 89.6608 39.0072C89.108 38.8195 88.5976 38.6241 88.1143 38.3903C87.1441 37.9511 86.1981 37.4613 85.2803 36.9227C84.3717 36.3901 83.5018 35.8422 82.6357 35.2176L83.7376 33.1829C85.6128 33.8266 87.5228 34.5164 89.3554 35.0145C89.8116 35.141 90.264 35.2482 90.6931 35.3249C91.052 35.4061 91.4193 35.4447 91.7873 35.4398C91.8994 35.4398 91.9884 35.39 91.8105 35.4207C91.6371 35.4649 91.4785 35.5535 91.3504 35.6774C91.1497 35.8538 91.0025 36.0819 90.9251 36.3365C90.8925 36.4528 90.8731 36.5723 90.8671 36.6928C90.8671 36.758 90.8671 36.6545 90.8478 36.6009L90.813 36.4169L90.6738 35.6889C90.2949 33.7424 89.9083 31.7894 89.5139 29.8301C89.1273 27.872 88.7175 25.9025 88.354 23.9521L92.924 23.0018Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    d: "M93.1536 21.3815C95.1796 23.5311 95.3613 30.1333 95.3613 30.1333L89.4961 32.873C89.4961 32.873 87.5939 28.6772 87.532 24.8799C87.4702 20.573 91.1238 19.2165 93.1536 21.3815Z",
    fill: "#FF7171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    opacity: 0.2,
    d: "M93.1536 21.3815C95.1796 23.5311 95.3613 30.1333 95.3613 30.1333L89.4961 32.873C89.4961 32.873 87.5939 28.6772 87.532 24.8799C87.4702 20.573 91.1238 19.2165 93.1536 21.3815Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    d: "M72.1278 29.4053C72.0942 29.4051 72.0612 29.3972 72.0311 29.3823C71.9393 29.3276 71.9084 29.2102 71.9615 29.1179L75.0546 23.8262C75.1129 23.7468 75.2224 23.7239 75.3081 23.7733C75.3938 23.8227 75.4279 23.9283 75.3871 24.0178L72.3134 29.3095C72.2751 29.374 72.2031 29.4112 72.1278 29.4053Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    d: "M81.725 44.123L70.0372 42.437C69.5439 42.3627 69.1639 41.9671 69.1131 41.4752L68.3399 25.4851C68.3283 25.269 68.4197 25.06 68.5869 24.9206C68.7541 24.7813 68.9775 24.7279 69.1904 24.7763L80.8783 26.4584C81.3717 26.5365 81.7516 26.9318 81.8062 27.424L82.5602 43.4141C82.5705 43.627 82.481 43.8326 82.3177 43.9712C82.1544 44.1098 81.9356 44.1659 81.725 44.123Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    d: "M81.4627 44.2846L69.7749 42.591C69.2808 42.517 68.8994 42.1217 68.8469 41.6292L68.093 25.6391C68.0801 25.4233 68.1706 25.2141 68.3373 25.0745C68.5039 24.935 68.7272 24.8815 68.9397 24.9302L80.6276 26.6124C81.123 26.6868 81.5047 27.084 81.5555 27.578L82.3288 43.5642C82.3475 43.7863 82.2562 44.0035 82.084 44.1468C81.9118 44.29 81.6801 44.3414 81.4627 44.2846Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    d: "M83.9605 33.2406L81.2115 31.7079L80.8906 35.624C80.8906 35.624 83.5197 36.4133 84.0958 35.076L83.9605 33.2406Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    d: "M78.1533 32.4093L78.54 35.3368L80.8945 35.628L81.2154 31.7119L78.1533 32.4093Z",
    fill: "#FF8B7B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigital);
export default __webpack_public_path__ + "static/media/digital.81854d30981f134281f916751c9412ed.svg";
export { ForwardRef as ReactComponent };